import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	storyPoints: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noStoryPoints: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	storyPoints: {
		id: 'issue-table-grouping.group-row.group-header.story-points-group-header.story-points',
		defaultMessage: '{points, plural, one {# point} other {# points}}',
		description: 'Story points count to show when grouping items by Story points',
	},
	noStoryPoints: {
		id: 'issue-table-grouping.group-row.group-header.story-points-group-header.no-story-points',
		defaultMessage: 'No points',
		description: 'Label for grouped items without Story points',
	},
});
export default messages;
